module.exports = __webpack_public_path__ + "static/17.1-c6a257d98d7d75bfba6eb188ca8a9c6a.jpg";